// TODO

import { SEAT_STATUSES } from '../constants'

const incrementInMap = (map, key) => {
  if (map.has(key)) {
    map.set(key, map.get(key) + 1)
  } else {
    map.set(key, 1)
  }
}

const statusesUpdate = (newStatuses, seats) => {
  const counts = new Map()

  Object.keys(newStatuses).forEach((groupRowId) => {
    const rowStatuses = newStatuses[groupRowId]
    if (typeof rowStatuses !== 'string') {
      // if not standing area
      Object.keys(rowStatuses).forEach((seatIndex) => {
        const newStatus = newStatuses[groupRowId][seatIndex]
        const seatId = groupRowId + ':' + seatIndex

        if (seats[seatId]) {
          if (Array.isArray(seats[seatId])) {
            seats[seatId].map((s) => s.statusUpdate(newStatus))
          } else {
            seats[seatId].statusUpdate(newStatus)
          }
        }
        incrementInMap(counts, newStatus)
      })
    }
  })

  return counts
}

const blocksStatusesUpdate = (newStatuses, blocks) => {
  const statuses = {}
  blocks.forEach((block) => {
    statuses[block.sgId] = { available: 0 }
  })

  for (const [rowId, rowStatuses] of Object.entries(newStatuses)) {
    const [groupId] = rowId.split('-')
    Object.values(rowStatuses).forEach((status) => {
      if (status === SEAT_STATUSES.AVAILABLE) {
        ++statuses[groupId].available
      }
    })
  }

  blocks.forEach((block) => {
    const status =
      statuses[block.sgId].available > 0
        ? SEAT_STATUSES.AVAILABLE
        : SEAT_STATUSES.BOOKED
    block.statusUpdate(status, statuses[block.sgId].available)
  })
}

const standingAreaStatusesUpdate = (newStatuses, standingAreas) => {
  standingAreas.forEach((standingArea) => {
    newStatuses[standingArea.sgId] &&
      standingArea.statusUpdate(newStatuses[standingArea.sgId])
  })
}

export { statusesUpdate, blocksStatusesUpdate, standingAreaStatusesUpdate }
